"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslatedCurrency = void 0;
var _react = _interopRequireDefault(require("react"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var TranslatedCurrency = function TranslatedCurrency(_ref) {
  var code = _ref.code,
    className = _ref.className;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  // @ts-ignore-next
  var text = t("currencies.".concat(code));
  return /*#__PURE__*/_react.default.createElement("p", {
    className: className
  }, text);
};
exports.TranslatedCurrency = TranslatedCurrency;